import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CODECLIENT = process.env.REACT_APP_CODE_CLIENT;
const SHAI = process.env.REACT_APP_SHAI;
// console.log('API_URL:', API_URL);


// Définition du type pour un support de presse (JAL)
export interface Jal {
  sId_Jal: string;
  sDep: string;
  sName_Jal: string;
  sAttestation: string;
  sJustif: string;
  nDiffusion?: string;
  sTypePresse: string;
  nTypePresse: string;
  nJalPref: string;
  nRectifGratuit: string;     
  nAdditifGratuit: string;
  nLogoAutorise: string;
}

// Service pour récupérer la liste des journaux via l'API
export const getJalList = async (
  params: Record<string, any>
): Promise<Jal[]> => {
  try {
    const response = await axios.post<Jal[]>( `${API_URL}/annonce/get-jal`, { ...params, sSHA1: SHAI, codeClient: CODECLIENT });
    
    return response.data;
  } catch (error: any) {
    console.error('Erreur lors de la récupération des journaux JAL:', error);
    // On peut rejeter l'erreur pour la gestion en aval
    return Promise.reject(
      error?.response?.data?.message || 'Erreur inconnue lors de fetch JAL'
    );
  }
};
